// extracted by mini-css-extract-plugin
export var main = "AboutLeap-module--main--18pnZ";
export var circle = "AboutLeap-module--circle--372Lr";
export var circleOne = "AboutLeap-module--circle-one--2MiXa";
export var circleTwo = "AboutLeap-module--circle-two--1hJ3k";
export var circleThree = "AboutLeap-module--circle-three--2NElr";
export var content = "AboutLeap-module--content--pfbiS";
export var title = "AboutLeap-module--title--3tvd9";